import {apiRoot} from "./apiRoot.ts";

export type ImportLogEntry = {
    activityCount: number,
    shiftCount: number,
    timestamp: string,
    filename: string,
    message: string,
    success: boolean
}

export const importLogSlice = apiRoot.injectEndpoints({
    endpoints: build => ({
        allImportLogs: build.query<ImportLogEntry[], void>({
            query: () => "/api/worktimeexpense/importLog",
        })
    })
})

export const {useAllImportLogsQuery} = importLogSlice